import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {LocaleProvider, Layout} from 'antd';
import {connect} from 'react-redux';
import vi_VN from 'antd/lib/locale-provider/vi_VN';
import './style/index.less';
import SiderMenu from './components/layouts/SiderMenu';
import HeaderNav from './components/layouts/HeaderNav';
import {POWER_BY} from './constants/configValues'
import {logout} from './actions/auth'
import {putUserChangePassword, clearError} from './actions/user'
const {Content, Footer} = Layout;

const styles = {
  content: {
    marginLeft: 8,
    marginRight: 8,
    marginTop: 8
  },
  footer: {
    textAlign: 'center',
    padding: 8
  }
}
class App extends Component {
  state = {
    collapsed: true,
    isMobile: false,
    clientHeight: 400
  };
  componentWillMount() {
    this.getClientWidth();
    window.onresize = () => {
      this.getClientWidth();
    }
  }

  getClientWidth = () => {
    const clientWidth = document.body.clientWidth;
    const clientHeight = document.body.clientHeight;
    this.setState({
      isMobile: clientWidth <= 992,
      clientHeight: clientHeight
    });
  };
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };
  logout = () => {
    const logoutRoute = this.props.location.pathname || '/';
    this.props.dispatch(logout({username: '', password: '', nextUrl: logoutRoute}));
  }

  handleUpdatePassword = (newPassword) => {
    this.props.dispatch(clearError())
    this.props.dispatch(putUserChangePassword(newPassword))
  }

  handleShowModalChangePassword = () => {
    this.props.dispatch(clearError())
  }

  render() {
    const {
      router,
      location,
      currentSystem,
      children,
      currentUser,
      userError
    } = this.props;
    const {collapsed, isMobile, clientHeight} = this.state
    const basePath = `/${currentSystem.ID}`
    const childrenWithProps = React.Children.map(children, (child) => React.cloneElement(child, {
      clientHeight: !isMobile
        ? clientHeight - 210
        : clientHeight - 170,
      isMobile: isMobile,
      location: location
    }));
    const role = currentUser
      ? currentUser.role
      : 256
    return (<LocaleProvider locale={vi_VN}>
      <Layout className="ant-layout-has-sider">
        {!isMobile && <SiderMenu path={location.pathname} collapsed={collapsed} basePath={basePath} role={role}/>}
        <Layout>
          <HeaderNav toggle={this.toggle} logout={this.logout} collapsed={collapsed} isMobile={this.state.isMobile} router={router} path={location.pathname} basePath={basePath} currentUser={currentUser} error={userError} onUpdatePassword={this.handleUpdatePassword} onShowModalChangePassword={this.handleShowModalChangePassword}/>
          <Content style={styles.content}>
            {childrenWithProps}
          </Content>
          {
            !isMobile
              ? <Footer style={styles.footer}>
                  {POWER_BY}
                </Footer>
              : null
          }
        </Layout>
      </Layout>
    </LocaleProvider>);
  }
}

App.propTypes = {
  dispatch: PropTypes.func,
  currentUser: PropTypes.object,
  currentSystem: PropTypes.object,
  userError: PropTypes.string
}

const mapStateToProps = function(state) {
  return {currentUser: state.user.currentUser, currentSystem: state.system.currentSystem, userError: state.user.error}
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js